import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

const Card: React.FC<CardProps> = ({ className = '', children, ...rest }) => {
  return (
    <div
      className={`bg-white text-text rounded-lg shadow-md p-6 ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card; 